import React from "react";
import WorkspaceInternalControls from "../../libraries/WorkspaceInternalControls";

interface ManagementUseOfExpertInternalControlsProps {
  onBack?: () => void;
  setActiveSection?: (section: string) => void;
  controlsListSection?: string;
}

export default function ManagementUseOfExpertInternalControls({ onBack, setActiveSection, controlsListSection }: ManagementUseOfExpertInternalControlsProps) {
  return (
    <WorkspaceInternalControls
      workspaceName="Management Use of Expert"
      onBack={onBack}
      setActiveSection={setActiveSection}
      controlsListSection={controlsListSection}
    />
  );
}
